export default "__VITE_ASSET__CsJvY_lU__"